import React, { useEffect, useRef, useState } from "react";
import Input from "../../../Components/Input/Input";
import { fetchCountryList, getViewCity, UpdateCity } from "../../../utils/api";
import { useParams } from "react-router-dom";
import { clickOutSide, isEmpty } from "../../../utils/common";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper";
import { useDebounce } from "../../../Components/hooks/useDebounce";
import RichTextEditor from "../../../Components/RichTextEditor/RichText";

const ViewCityDetails = () => {
  const { id } = useParams();
  const [viewCityData, setViewCityData] = useState({
    name: null,
    active: null,
    code: null,
    countryCode: null,
    feedSource: null,
    description:null
  });
  const [errors, setErrors] = useState({});
  const [images, setImages] = useState([]);
  const [message, setMessage] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [countryList, setCountryList] = useState([]);
   const outSideRefCountry = useRef(null)


    const debounceValue = useDebounce(viewCityData?.countryCode, 500);
         
           useEffect(() => {
             fetchCountryList()
               .then((response) => {
                 setCountryList(response?.data?.data?.countries || []);
               })
               .catch((error) => {
                 console.error("Failed to fetch country list:", error);
               });
           }, []);
         
           useEffect(() => {
             const filtered = countryList.filter((country) => (country?.name || "").toLowerCase().includes((debounceValue || "").toLowerCase()));
             setFilteredCountries(filtered || [])
           }, [debounceValue, countryList]);
  
  
  
  
  
           const ViewCity = () => {
            const param = id;
            getViewCity(param).then((resp) => {
              if (resp) {
                setViewCityData(resp?.data?.data);
                setImages(resp?.data?.data?.image ? [resp?.data?.data?.image] : []); // Add backend image
                setIsUpdating(true); // Set to updating mode since data is being viewed
              }
            });
          };

  useEffect(() => {
    ViewCity();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!viewCityData.name) newErrors.name = "City Name is required.";
    if (viewCityData.active === "") newErrors.active = "Status is required.";
    if (!viewCityData.code) newErrors.code = "City Code is required.";
    if (!viewCityData.countryCode) newErrors.countryCode = "Country Code is required.";
    if (!viewCityData.feedSource) newErrors.feedSource = "Feed Source is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setViewCityData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      url: URL.createObjectURL(file), // Local preview URL for uploaded images
    }));
    setImages((prev) => [...prev, ...newImages]); // Merge with existing images
    setMessage("Images uploaded successfully!");
    setTimeout(() => setMessage(""), 3000);
  };
  

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    const newImages = files.map((file) => ({
      id: Date.now() + Math.random(),
      file,
      url: URL.createObjectURL(file),
    }));
    setImages((prev) => [...prev, ...newImages]);
  };

  const preventDefault = (e) => e.preventDefault();

  const handleUpdateCity = () => {
    if (!validateForm()) return;
  
    const formData = new FormData();
  
    // Append JSON data to FormData
    const jsonData = {
      id,
      code:viewCityData.code,
      name: viewCityData.name,
      active: viewCityData.active === "true"? true:false,
      countryCode: viewCityData.countryCode,
      feedSource: viewCityData.feedSource,
      description:viewCityData.description
    };
    formData.append("request", JSON.stringify(jsonData));
  
    // Append files to FormData
    images.forEach((image, index) => {
      formData.append(`image`, image.file);
    });
  
    UpdateCity(formData).then((resp) => {
      if (resp) {
        setMessage({type:"success",message:"City details updated successfully!"});
       // ViewCity(); // Refresh data after update
      }
      else{
        setMessage({type:"error",message:"Failed to update city details."});
      }
    });
  };
  useEffect(() =>{
   if( isEmpty(message)) return;
  
   setTimeout(() =>{
    setMessage({})
   },5000)
  
    },[message])

    const handleCountrySelect = (country) => {
      setViewCityData((prevData) => ({
        ...prevData,
       // country: country.name,
        countryCode: country.iso2,
      }));
      setIsOpen(false)
      setFilteredCountries([]);
    };

    useEffect(()=>{
      if(!outSideRefCountry) return
      clickOutSide(outSideRefCountry,()=>setIsOpen(false));
      return  clickOutSide(outSideRefCountry,()=>setIsOpen(false),"remove")
    },[outSideRefCountry]);

    const handleDescriptionChange = (value) => {
      setViewCityData((prevData) => ({
        ...prevData,
        description: value, // Update description in viewHotelData
      }));
    }
  

  return (
    <>

        {!isEmpty(message) && (
              <AlertWrapper className={`${message.type} globle`}>
                <span className="close" onClick={() => setMessage({})}>
                  ×
                </span>
                {message.message}
              </AlertWrapper>
            )}
    
      <div className="main_container">
      <div className="userlist_head mb-5">

      <div className="userlist_heading">
              <div className="userlist_left">
                <label>City Details</label>
              </div>
      </div>
      </div>
      <div className="subadmin_container justify-between flex column gap-20" style={{padding:"30px"}} >
          <div style={{flex:"1 1 100%"}}>
           
            <div className="flex gap-10">
              <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">City Name:</label>
                </div>
                <Input
                  type="text"
                  maxLength={50}
                  placeholder="City Name"
                  name="name"
                  value={viewCityData.name}
                  onChange={handleInputChange}
                />
                {errors.name && <p className="error fs-12 mt-10">{errors.name}</p>}
              </div>

              <div className="input-field" style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Status:</label>
                </div>
                <select
                  style={{ width: "330px" }}
                  className="input_select_field"
                  name="active"
                  value={viewCityData.active}
                  onChange={handleInputChange}
                >
                  <option value="">Select Status</option>
                  <option value="true">ACTIVE</option>
                  <option value="false">INACTIVE</option>
                </select>
                {errors.active && <p className="error fs-12 mt-10">{errors.active}</p>}
              </div>
            </div>

            <div className="flex gap-10 mt-20">
              <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">City Code</label>
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="City Code"
                  name="code"
                  value={viewCityData.code}
                  onChange={handleInputChange}
                  disabled={isUpdating} // Disable when updating
                />
                {errors.code && <p className="error fs-12 mt-10">{errors.code}</p>}
              </div>

              
             <div  style={{flex:"1 1 50%",position:"relative"}} ref ={outSideRefCountry}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Country Code:</label>
                  </div>
                  <Input
                    type="text"
                   
                    placeholder="Country Code"
                    name="countryCode"
                    value={viewCityData?.countryCode || ""}
                    onChange={handleInputChange}
                    onFocus={()=>setIsOpen(true)}
                  />
                    {filteredCountries.length > 0 && isOpen && (
                <div className="dropdown mt-10" style={{maxWidth:"330px",width:"100%",background:"#fff",position:"absolute"}}>
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="dropdown-item fs-14"
                      style={{paddingBottom:"5px",borderBottom:"1px solid #8080803d",paddingTop:"5px",cursor:"pointer"}}
                      onClick={() => handleCountrySelect(country)}
                    >
                      {country.name} ({country.iso2})
                    </div>
                  ))}
                </div>
              )}
             
                </div>
             
            </div>

            <div className="flex gap-10 mt-20">
              <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Feed Source</label>
                </div>
                <Input
                  type="text"
                  maxLength={50}
                  placeholder="Feed Source"
                  name="feedSource"
                  value={viewCityData.feedSource}
                  onChange={handleInputChange}
                />
                {errors.feedSource && (
                  <p className="error fs-12 mt-10">{errors.feedSource}</p>
                )}
              </div>
              {isUpdating && ( // Only show this section during update
                <div style={{ flex: "1 1 50%" }}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Upload File:</label>
                  </div>
                  <div
                    style={{ flex: "1 1 50%" }}
                    onDrop={handleDrop}
                    onDragOver={preventDefault}
                    onDragEnter={preventDefault}
                    onDragLeave={preventDefault}
                  >
                    <input
                      style={{ width: "330px" }}
                      type="file"
                      multiple
                      accept=".jpg, .jpeg, .png, .webp, .avi"
                      id="fileUpload"
                      onChange={handleFileChange}
                    />
                  </div>
                  {errors.files && (
                    <p className="error fs-12 mt-10">{errors.files}</p>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="flex gap-10 mt-20">
  <div>
    <div className="labelname mb-5">
      <label className="fw-bold">Images</label>
    </div>
    <div className="image-preview-container" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      {images.map((image, index) => (
        <div key={index} style={{ position: "relative" }}>
          <img
            src={image.url || `https://travelbookings.s3.ap-south-1.amazonaws.com/${image}`}
            alt={`City Image ${index + 1}`}
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "8px",
              objectFit: "cover",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
          {image.file && (
            <button
              style={{
                position: "absolute",
                top: "5px",
                right: "5px",
                background: "red",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={() =>
                setImages((prev) =>
                  prev.filter((_, imgIndex) => imgIndex !== index)
                )
              }
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  </div>
         </div>


          <div className="flex gap-10">
              <div style={{flex:"1 1 50%"}}>
                 
                <RichTextEditor onContentChange={handleDescriptionChange} initialContent={viewCityData?.description}></RichTextEditor>
                  
          
          
          </div> 
               
               </div>


          

          <div className="mt-50">
            <button  onClick={handleUpdateCity} className="userlist_btn">
              Update City
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCityDetails;
